module.exports = __webpack_public_path__ + "static/img/Empire_logo.23fa630.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pos/Empire_logo.jpeg
// module id = 1203
// module chunks = 34